import { useSafeAreaInsets } from 'react-native-safe-area-context';

export default useSafeAreaInsets;
